<div class="modal-window__header">
  <div class="modal-window__title">
    {{ "calibration.settings" | translate }}
  </div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  class="o-grid--medium u-mt--medium"
  (ngSubmit)="updateCalibration()">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label class="c-form-label">{{ "calibration.nextcalibration" | translate }}</label>
    <div class="c-input-group">
      <datepicker-input
        [inputDate]="calibration.nextDate"
        (dateChange)="calibration.nextDate = $event">
      </datepicker-input>
    </div>
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <div class="o-grid">
      <div class="o-grid__item col-12 col-sm-6">
        <label class="c-form-label">{{ "calibration.interval" | translate }}</label>
        <mat-select
          #interval="ngModel"
          [(ngModel)]="calibration.interval"
          name="calInterval"
          id="calInterval"
          [class.is-invalid]="interval.touched && interval.invalid"
          class="c-user-menu__select c-select c-select--lg"
          (ngModelChange)="setCalFrequencyList()"
          required>
          <mat-option
            *ngFor="let interval of intervals"
            [value]="interval.id">
            {{ interval.localizedTitle | translate }}
          </mat-option>
        </mat-select>
        <div
          *ngIf="interval.touched && interval.invalid"
          class="c-form-alert">
          {{ "calibration.intervalrequirederror" | translate }}
        </div>
      </div>

      <div class="o-grid__item col-12 col-sm-6">
        <label class="c-form-label">{{ "calibration.frequency" | translate }}</label>
        <mat-select
          #frequency="ngModel"
          [(ngModel)]="calibration.frequency"
          name="calFrequency"
          id="calFrequency"
          class="c-user-menu__select c-select c-select--lg"
          [class.is-invalid]="frequency.touched && frequency.invalid"
          (ngModelChange)="refreshNextScheduleDate()"
          required>
          <mat-option
            *ngFor="let item of frequencyList"
            [value]="item"
            >{{ item }}</mat-option
          >
        </mat-select>
        <div
          *ngIf="frequency.touched && frequency.invalid"
          class="c-form-alert">
          {{ "calibration.frequencyrequirederror" | translate }}
        </div>
      </div>

      <div class="o-grid__item col-12 col-sm-12">
        <label class="c-form-label">{{ "calibration.status" | translate }}</label>
        <mat-select
          #calibrationStatus="ngModel"
          [(ngModel)]="calibration.calibrationStatus"
          name="calibrationStatus"
          id="calibrationStatus"
          class="c-user-menu__select c-select c-select--lg"
          [class.is-invalid]="calibrationStatus.touched && calibrationStatus.invalid"
          required>
          <mat-option
            *ngFor="let status of calibrationStatuses"
            [value]="status.id">
            {{ status.title }}
          </mat-option>
        </mat-select>
        <div
          *ngIf="calibrationStatus.touched && calibrationStatus.invalid"
          class="c-form-alert">
          {{ "calibration.statusrequirederror" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid || !calibration.nextDate || isLoading">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading">{{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
